import { createSlice } from '@reduxjs/toolkit'
import {RootState} from './store'
import { IBadgeStatus } from '../interface/IUser'


const BadgeStatusSlice = createSlice({
  name: 'BadgeStatusSlice',
   initialState: {
    taskCount:1,
    orderCount:1,
    

  } as IBadgeStatus,
  reducers: {    
    increment: (state, action) => {    
      state.taskCount = action.payload.taskCount;
      state.orderCount = action.payload.orderCount; 
      return 
    }
  },
})



// Action creators are generated for each case reducer function
export const {   increment } = BadgeStatusSlice.actions
export const BadgeStatusSliceData = (state: RootState)=>state
export default BadgeStatusSlice.reducer